import { setInitialState } from '../../../utils/reducerOperations';
export function Default() {
    return {
        getOrganizationProfileApi: {
            ...setInitialState(),
            isDataFetched: false
        }
    };
}
